import { Button, useMutation, useNotify, useRefresh } from "react-admin";
import DeleteIcon from "@material-ui/icons/Delete";

interface IDeleteNotTakingReportButton {
  notTakingReportId: number;
}

const DeleteNotTakingReportButton = ({
  notTakingReportId,
}: IDeleteNotTakingReportButton) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const [handleChangeStatusStudent, { loading }] = useMutation(
    {
      type: "delete",
      resource: `notTakingReports`,
      payload: {
        id: notTakingReportId,
      },
    },
    {
      onSuccess: ({ data }) => {
        notify(`Successfully delete the not taking reports.`, "info");
        refresh();
      },
      onFailure: (error) =>
        notify(
          `Failed delete the not taking reports, error: ${error.message}`,
          "warning"
        ),
    }
  );

  return (
    <Button
      onClick={handleChangeStatusStudent}
      color="primary"
      label={loading ? "Please wait..." : "Delete"}
      style={{ backgroundColor: "rgb(244, 67, 54)" }}
    >
      <DeleteIcon />
    </Button>
  );
};

export default DeleteNotTakingReportButton;
